"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteService = exports.ROUTE_PREFIX = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const route_recognizer_1 = tslib_1.__importDefault(require("route-recognizer"));
const login_page_1 = require("../page/auth/login.page");
const missing_page_1 = require("../page/missing.page");
const page_layout_1 = require("../page/page.layout");
const page_registry_1 = require("../page/page.registry");
const index_1 = require("./index");
exports.ROUTE_PREFIX = '#';
class RouteService {
    constructor() {
        this.__priority = 100;
        this.hasLoaded = false;
        this.tokensLoaded = false;
        this.profilesLoaded = false;
        this.params = mobx_1.observable.map({}, { deep: false });
    }
    init() {
        (0, mobx_1.reaction)(() => this.tokensLoaded, () => this.firstLoad());
        (0, mobx_1.reaction)(() => this.profilesLoaded, () => this.firstLoad());
    }
    bindRoutes() {
        this.router = new route_recognizer_1.default();
        for (const pageEntry of page_registry_1.PageRegistry.pages) {
            const paths = Array.isArray(pageEntry.config.path) ? pageEntry.config.path : [pageEntry.config.path];
            for (const path of paths) {
                this.router.add([{ path, handler: pageEntry }]);
            }
        }
        this.layout = new page_layout_1.PageLayout();
        index_1.Services.Render.mount(index_1.Services.Window.document.body, this.layout, 'root');
        index_1.Services.Window.window.addEventListener('hashchange', (ev) => this.resolveRoute(ev.newURL));
    }
    // Once we check department tokens and get the user profile we resolve the route
    firstLoad() {
        if (this.tokensLoaded && this.profilesLoaded && !this.hasLoaded) {
            this.hasLoaded = true;
            this.resolveRoute(window.location.href);
        }
    }
    departmentReset() {
        this.tokensLoaded = false;
        this.profilesLoaded = false;
        this.hasLoaded = false;
    }
    get active() {
        return this.layout != null ? this.layout.page : null;
    }
    supportDepartmentChange() {
        return this.active != null && this.active.config.supportDepartmentChange;
    }
    setAllParams(params, history) {
        for (const key of Object.keys(params)) {
            if (this.params.get(key) !== params[key]) {
                this.params.merge(params);
                this.applyParams(history);
                return;
            }
        }
    }
    setParam(key, value, history) {
        if (this.params.get(key) !== value) {
            this.params.set(key, value);
            this.applyParams(history);
        }
    }
    openNewWindow(name, params) {
        const url = this.getRouteURL(name, params);
        index_1.Services.Window.window.open(url, '_blank');
    }
    getRouteURL(name, params) {
        const config = page_registry_1.PageRegistry.getConfig(name);
        if (config == null) {
            return undefined;
        }
        return this.compileURL(config, params);
    }
    go(name, params) {
        const url = this.getRouteURL(name, params);
        this.goRaw(url);
    }
    goRaw(url) {
        index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Route, 'route', url, 1);
        index_1.Logger.info({ url }, 'Routing');
        index_1.Services.Window.window.location.href = url;
    }
    isPoleLoading() {
        // return this.route[1] === this.PAGE.dashboard.poleLoading;
        return true;
    }
    isPoleStatus() {
        // return this.route[1] === this.PAGE.dashboard.poleStatus;
        return true;
    }
    applyParams(history) {
        const $window = index_1.Services.Window.window;
        if ($window == null) {
            return;
        }
        const state = null;
        const title = null;
        const path = this.compileURL(this.active.config, this.params.toJSON());
        if (typeof $window.history.pushState === 'function') {
            if (history) {
                $window.history.pushState(state, title, path);
            }
            else {
                $window.history.replaceState(state, title, path);
            }
        }
        else {
            $window.location.href = path;
        }
    }
    compileURL(config, params) {
        if (config.type === 'external') {
            return config.path;
        }
        let url = this.getMatchingPath(config, params);
        let paramsString = '';
        if (params != null && Object.keys(params).length > 0) {
            // Replace path params (/map/:location)
            const args = {};
            for (const key of Object.keys(params)) {
                if (params[key] != null) {
                    args[key] = params[key];
                }
            }
            url = url.replace(/:([^/]+)/g, (match, token) => {
                const value = args[token];
                delete args[token];
                return value;
            });
            // Build query string (&foo=bar)
            if (Object.keys(args).length > 0) {
                paramsString =
                    '?' +
                        Object.keys(args)
                            .map((key) => `${index_1.Services.Window.window.encodeURIComponent(key)}=${index_1.Services.Window.window.encodeURIComponent(args[key])}`)
                            .join('&');
            }
        }
        return `/${exports.ROUTE_PREFIX}${url}${paramsString}`;
    }
    getMatchingPath(config, params) {
        const paths = Array.isArray(config.path) ? config.path : [config.path];
        params = params || {};
        let matchingPath = paths[0];
        let matchCount = 0;
        for (let i = 0; i < paths.length; i++) {
            const args = paths[i].match(/:([^/]+)/g) || [];
            let argMatchCount = 0;
            for (let arg of args) {
                if (params[arg.substr(1)] != null) {
                    argMatchCount += 1;
                }
            }
            if (argMatchCount > matchCount) {
                matchingPath = paths[i];
                matchCount = argMatchCount;
            }
        }
        return matchingPath;
    }
    resolveRoute(url) {
        let path = url;
        if (!url.startsWith('/')) {
            if (url.includes(exports.ROUTE_PREFIX)) {
                path = url.split(exports.ROUTE_PREFIX).pop();
            }
            else {
                path = '/';
            }
        }
        const results = this.router.recognize(path);
        let page;
        let params = {};
        if (results == null || results.length === 0) {
            page = new missing_page_1.MissingPage();
        }
        else {
            const result = results[0];
            const pageEntry = result.handler;
            if (pageEntry.config.auth.required && !index_1.Services.User.isAuthenticated) {
                page = new login_page_1.LoginPage(`/${exports.ROUTE_PREFIX}${path}`);
            }
            else if (
            // Check if the user has the correct tokens and/or user roles to access the requested page
            (pageEntry.config.auth.tokens && !index_1.Services.Token.hasAll(pageEntry.config.auth.tokens)) ||
                (pageEntry.config.auth.userLevel &&
                    !index_1.Services.UserProfile.isOneOf(index_1.Services.UserProfile.get(index_1.Services.User.current.objectId), pageEntry.config.auth.userLevel)) ||
                (pageEntry.config.auth.userLevelBlackList &&
                    index_1.Services.UserProfile.isOneOf(index_1.Services.UserProfile.get(index_1.Services.User.current.objectId), pageEntry.config.auth.userLevelBlackList))) {
                page = new missing_page_1.MissingPage(403);
            }
            else {
                page = new pageEntry.page();
            }
            params = Object.assign(Object.assign({}, result.params), results.queryParams);
        }
        var previousPage = this.layout.page;
        if (!previousPage || (previousPage && previousPage.config.name !== page.config.name)) {
            this.layout.setPage(page);
            this.params.replace(params);
            if (previousPage && this.layout.page !== previousPage) {
                previousPage.unload();
            }
        }
        page_layout_1.PageLayoutState.nav.setVisible(page.config.layout.nav);
    }
}
exports.RouteService = RouteService;
tslib_1.__decorate([
    mobx_1.observable
], RouteService.prototype, "tokensLoaded", void 0);
tslib_1.__decorate([
    mobx_1.observable
], RouteService.prototype, "profilesLoaded", void 0);
tslib_1.__decorate([
    mobx_1.action
], RouteService.prototype, "departmentReset", null);
tslib_1.__decorate([
    mobx_1.action
], RouteService.prototype, "resolveRoute", null);
//# sourceMappingURL=route.service.js.map